module.exports = __webpack_public_path__ + "static/media/3.4715bfe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/3.jpg
// module id = 100
// module chunks = 0